import { Component, Fragment, h, Prop, State } from '@stencil/core';
import { ButtonSize } from '../../atoms/rentware-button/types';
import { redeemPrepaymentCode, updatePrepayStatus } from '../../../redux/actions';
import { store } from '../../../redux/store';
import { CodeStatus } from '../utils/types';
import { RootState } from '../../../redux/reducers';
import { Unsubscribe } from '@stencil/redux';
import { t } from '../../../redux/utils';

@Component({
  tag: 'rtr-payment-prepayment',
  styleUrl: '../style.sass',
  shadow: false,
})
export class RtrPaymentPrepayment {
  @Prop({ mutable: true }) prepayCodeStatus: CodeStatus;
  @Prop() withCode: boolean = true;

  @State() waiting: boolean = false;
  @State() prepayCode: string;

  redeemPrepaymentCode!: typeof redeemPrepaymentCode;
  updatePrepayStatus!: typeof updatePrepayStatus;
  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        prepayCodeStatus: state.app.prepayStatus,
      };
    });

    store.mapDispatchToProps(this, {
      redeemPrepaymentCode,
      updatePrepayStatus,
    });

    //this param is always loaded before prepayment, so it is safe to check it when loading component
    //other solution is to @watch() it in payment component, but we are avoiding watching props when not necessary
    if (!this.withCode) {
      this.updatePrepayStatus(CodeStatus.NotNeeded);
    }
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  handleChangePrepayCode = (prepayCode: string) => {
    this.prepayCode = prepayCode;
  };

  onRedeemSuccess = () => {
    this.updatePrepayStatus(CodeStatus.Accepted);
    this.waiting = false;
  };

  onRedeemError = () => {
    this.updatePrepayStatus(CodeStatus.Error);
    this.waiting = false;
  };

  handleCodeRedeem = () => {
    this.waiting = true;
    this.redeemPrepaymentCode(this.prepayCode, this.onRedeemSuccess, this.onRedeemError);
  };

  get inputLabel() {
    return t('payment.prepaymentLabel');
  }

  get inputPlaceholder() {
    return t('payment.passcodePlaceholder');
  }

  get codeErrorText() {
    return t('payment.passcodeError');
  }

  get prepaymentInfo() {
    return t('payment.notesPrepayment');
  }

  get passedCodeInfo() {
    return t('payment.passcodeSuccessfullyAdded', { code: this.prepayCode });
  }

  get buttonText() {
    return t('payment.btnLabelUsePasscode');
  }

  render() {
    if (this.prepayCodeStatus === CodeStatus.Accepted) {
      return (
        <Fragment>
          <rentware-spacer size="L" />
          {this.passedCodeInfo}
          <rentware-spacer size="S" />
        </Fragment>
      );
    }

    return (
      <Fragment>
        {this.waiting && <rentware-spinner withOverlay={true} />}
        <rentware-spacer size="S" />
        {this.prepaymentInfo}
        <rentware-spacer size="L" />
        {this.prepayCodeStatus !== CodeStatus.NotNeeded && (
          <Fragment>
            <rtr-input onInput={e => this.handleChangePrepayCode(e.target.value)} type="text" name="prepayment-code" label={this.inputLabel} placeholder={this.inputPlaceholder} />
            {this.prepayCodeStatus === CodeStatus.Error && <span class="error">{this.codeErrorText}</span>}
            <rentware-spacer size="S" />
            <rentware-button buttonText={this.buttonText} isWaiting={this.waiting} appearance={{ fullWidth: true, size: ButtonSize.XL }} onClick={this.handleCodeRedeem} />
          </Fragment>
        )}
      </Fragment>
    );
  }
}
